var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.2044 20.8697C42.2808 22.0085 42.2808 24.9915 40.2044 26.1303L4.44269 45.745C2.44341 46.8416 1.54231e-06 45.3949 1.64513e-06 43.1147L3.41404e-06 3.88535C3.51686e-06 1.60508 2.44341 0.158441 4.4427 1.25501L40.2044 20.8697Z","fill":"#FFFBE7"}));
}

Play.defaultProps = {"width":"42","height":"47","viewBox":"0 0 42 47","fill":"none"};

module.exports = Play;

Play.default = Play;
